import React from "react";
import { Col, Row } from "react-bootstrap";
import { WfControlProps } from "./ControlProps";
import ComponentLabel from "../../../../../../components/ControlComponents/ComponentLabel";

export function WfUnsupport({ layout, layoutLength }: Readonly<WfControlProps>) {
  return (
    <>
        <ComponentLabel
          colText={2}
          rowIdx={1}
          colIdx={0}
          template={layout.template}
        />
        <Col xs={12} lg={layoutLength === 1 ? 10 : 4}>
          <small>type {layout.template?.type} unsupport control</small>
        </Col>
    </>
  );
}
